export const calcularPorcentajes = (data) => {
  const resultados = {};
  let sumaPorcentajes = 0;

  const resultadosFiltrados = Object.entries(data).reduce(
    (acc, [key, value]) => {
      if (key !== 'sec1' && key !== 'sec2') {
        acc[key] = value;
      }
      return acc;
    },
    {},
  );

  Object.keys(resultadosFiltrados).forEach((seccion) => {
    let suma = 0;
    let conteoPreguntas = 0;

    Object.keys(resultadosFiltrados[seccion]).forEach((pregunta) => {
      const valor = resultadosFiltrados[seccion][pregunta].value;

      if (typeof valor === 'number') {
        suma += valor;
        conteoPreguntas++;
      }
    });

    const porcentajeSeccion =
      conteoPreguntas > 0 ? (suma / conteoPreguntas) * 100 : 0;

    // Redondear el porcentaje de la sección a dos decimales
    const porcentajeRedondeado = Number(porcentajeSeccion.toFixed(2));

    resultados[seccion] = {
      porcentaje: porcentajeRedondeado,
      totalPreguntas: conteoPreguntas,
    };
    sumaPorcentajes += porcentajeSeccion;
  });

  const porcentajeTotalSinRedondear = sumaPorcentajes / 6;

  const porcentajeTotal = Number(porcentajeTotalSinRedondear.toFixed(2));

  return { resultados, porcentajeTotal };
};
